// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-title-container {
  margin-right: 16px;
}
.page-title-container .page-title {
  font-size: 20px;
  font-weight: 500;
  margin: 0;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 320px;
}`, "",{"version":3,"sources":["webpack://./src/app/theme/components/page-title/page-title.component.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;AAFF;AAIE;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAFJ","sourcesContent":["// ==========================================================================\r\n// Component: Page-title.component\r\n// ==========================================================================\r\n.page-title-container {\n  margin-right: 16px;\n\n  .page-title {\n    font-size: 20px;\n    font-weight: 500;\n    margin: 0;\n    line-height: 1.2;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 320px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
